import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../env"
import Title from "../../components/Title";
import HomeTab from "./program/HomeTab";
import ParticipantsTab from "./program/ParticipantsTab";
import RoasterTab from "./program/RoasterTab";
import InvitesTab from "./program/InvitesTab";
import MatchingTab from "./program/MatchingTab";

const TABS = ['home', 'participants', 'pairs', 'invites', 'matching']

export default function Program() {

    const { id, tab } = useParams()
    const navigate = useNavigate()

    const [program, setProgram] = useState({})

    const activeTab = TABS.includes(tab) ? tab : 'home'

    useEffect(() => {
        api.get(`programs/${id}`)
            .then(res => { setProgram(res.data) })
            .catch(err => navigate('..'))
    }, [id])

    const goToTab = (key) => {
        if (tab) navigate(key === 'home' ? '../' : `../${key}`)
        else navigate(key === 'home' ? '.' : key)
    }

    const goBack = () => navigate(tab ? '../..' : '..')

    return (
        <div className="standard-padding page-xl-centered showing">
            <Title className={'v-spacer-xs'} back={goBack}>{program.name}</Title>
            <div className="v-spacer-m"></div>
            <div className="flex gap-xs" style={{ borderBottom: '1px solid rgba(var(--neutral), 40%)' }}>
                {TABS.map(tab => (
                    <button
                        key={tab}
                        className={`text tab ${activeTab === tab ? 'selected' : ''}`}
                        onClick={() => goToTab(tab)}
                    >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                ))}
            </div>
            <div className="v-spacer-m"></div>
            {program?.id && (
                <>
                    <div style={{ display: activeTab === 'home'         ? 'block' : 'none' }}><HomeTab         program={program} /></div>
                    <div style={{ display: activeTab === 'participants' ? 'block' : 'none' }}><ParticipantsTab program={program} /></div>
                    <div style={{ display: activeTab === 'pairs'        ? 'block' : 'none' }}><RoasterTab      program={program} /></div>
                    <div style={{ display: activeTab === 'invites'      ? 'block' : 'none' }}><InvitesTab      program={program} /></div>
                    <div style={{ display: activeTab === 'matching'     ? 'block' : 'none' }}><MatchingTab     program={program} /></div>
                </>
            )}
        </div>
    )
}
